<template>
  <template v-if="pageList == 'prodstatistics'">
    <!-- 產能統計 -->
    <prodStatistics></prodStatistics>
  </template>
  <template v-else-if="pageList == 'heattreatmentinquire'">
    <!-- 歷史參數查詢 -->
    <heatTreatmentInquire></heatTreatmentInquire>
  </template>
  <template v-else-if="pageList == 'heatanalysis'">
    <!-- 統計分析 -->
    <heatAnalysis></heatAnalysis>
  </template>
  <template v-else-if="pageList == 'inspecttimeout'">
    <!-- 自主檢驗超時 -->
    <inspectTimeout></inspectTimeout>
  </template>
  <template v-else-if="pageList == 'opratestatistics'">
    <!-- 稼動率統計 -->
    <opRateStatistics></opRateStatistics>
  </template>
  <template v-else-if="pageList == 'failstatistics'">
    <!-- 故障統計 -->
    <failStatistics></failStatistics>
  </template>
  <template v-else-if="pageList == 'feedinquire'">
    <!-- 入料參數查詢 -->
    <feedInquire></feedInquire>
  </template>
</template>

<script>
import { useStore } from "vuex";
import { computed, onUnmounted, provide, ref, watch } from "@vue/runtime-core";
import prodStatistics from "@/components/statisticalReports/prodStatistics";
import heatTreatmentInquire from "@/components/statisticalReports/heatTreatmentInquire";
import heatAnalysis from "@/components/statisticalReports/heatAnalysis";
import inspectTimeout from "@/components/statisticalReports/inspectTimeout";
import opRateStatistics from "@/components/statisticalReports/opRateStatistics";
import failStatistics from "@/components/statisticalReports/failStatistics";
import feedInquire from "@/components/statisticalReports/feedInquire";
export default {
  components: {
    prodStatistics,
    heatTreatmentInquire,
    heatAnalysis,
    inspectTimeout,
    opRateStatistics,
    failStatistics,
    feedInquire,
  },
  setup() {
    const store = useStore();

    //getters
    const sideBarSelect = computed(
      () => store.getters["sideBarTree/get_sideBarSelect"]
    );

    const pageList = ref();
    const pageListChild = ref();

    //function
    const setSessionItems = () => {
      sessionStorage.setItem("mes-statisticalReports-pageList", pageList.value);
      sessionStorage.setItem(
        "mes-statisticalReports-pageListChild",
        pageListChild.value
      );
    };
    window.addEventListener("beforeunload", setSessionItems);

    watch(sideBarSelect, (newValue) => {
      pageList.value = newValue.pageList;
      pageListChild.value = newValue.pageListChild;
    });

    setTimeout(() => {
      pageList.value = sideBarSelect.value.pageList;
      pageListChild.value = sideBarSelect.value.pageListChild;

      //session資料
      const mesStatisticalReportsPageList = sessionStorage.getItem(
        "mes-statisticalReports-pageList"
      );
      const mesStatisticalReportsPageListChild = sessionStorage.getItem(
        "mes-statisticalReports-pageListChild"
      );
      sessionStorage.removeItem("mes-statisticalReports-pageList");
      sessionStorage.removeItem("mes-statisticalReports-pageListChild");
      if (mesStatisticalReportsPageList != null) {
        pageList.value = mesStatisticalReportsPageList;
      }
      if (mesStatisticalReportsPageListChild != null) {
        pageListChild.value = mesStatisticalReportsPageListChild;
      }
    }, 0);

    provide("pageList", pageList);
    provide("pageListChild", pageListChild);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
    });

    return { pageList };
  },
};
</script>

<style></style>
<style lang="scss"></style>
